<template>
    <div class="Labor_cost_statistics">
      <el-form :inline="true" class="filter-form" label-width="85px">
        <el-form-item label="姓名：">
          <el-input v-model="filters.name" placeholder="请输入姓名" clearable />
        </el-form-item>
        <el-form-item label="统计时间：">
          <el-date-picker
            style="width: 260px;"
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label-width="20px">
          <el-button type="primary" @click="onSearch">搜索</el-button>
          <el-button @click="onReset">重置</el-button>
          <el-button type="primary" style="margin-bottom: 16px;" @click="onexport" :loading="exportloading">导出</el-button>
        </el-form-item>
      </el-form>
  
      <main v-loading="Workloadstatisticsloading">
          <div class="table_title">
            工作时长数据
          </div>
          <el-table :data="tableData" style="width: 100%;margin-bottom: 16px;">
              <el-table-column prop="realName" label="姓名" align="center" />
              <el-table-column prop="time1" label="实践小时数" align="center" />
              <el-table-column prop="time2" label="例会小时数" align="center" />
              <el-table-column prop="time3" label="培训小时数" align="center" />
          </el-table>
      </main>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        filters: {
          workDetailKey:'',
          name: '',
          status:'',
          from:'',
          to:'',
          exportFlag:'0',
          mode:1
        },
        dateRange:[],
        tableData: [],
        Workloadstatisticsloading:false,
        exportloading:false,
      };
    },
    watch:{
      dateRange(newval){
        if(newval==null){
          this.filters.from=''
          this.filters.to=''
        }else{
          this.filters.from=newval[0]
          this.filters.to=newval[1]
        }
      }
    },
    created(){
      this.onSearch()
    },
    methods: {
      onSearch() {
        this.Workloadstatisticsloading=true;
        this.$Http_Post('/management/getSalaryList',this.filters).then(res=>{
            this.Workloadstatisticsloading=false;
            if(res.Code==200 || res.Code==0){
              this.tableData=res.Data;
            }else{
                this.$message.error(res.Message)
            }
        })
      },
      onReset() {
        this.filters.name = '';
        this.dateRange = [];
        this.onSearch();
      },
      onexport(){
        this.exportloading=true;
        this.filters.exportFlag=1;
        this.$Http_Post('/management/getSalaryList',this.filters).then(res=>{
            this.exportloading=false;
            this.filters.exportFlag=0;
            if(res.Code==200 || res.Code==0){
              window.open(res.Data);
              this.$message.success(res.Message);
            }else{
                this.$message.error(res.Message)
            }
        })
      },
    },
  };
  </script>
  
  <style>
  .Labor_cost_statistics .filter-form {background: #fff;padding: 16px 0 0;margin-bottom: 16px;}
  .Labor_cost_statistics .table_title{background: #E4EAF2;padding: 15px 0;text-align: center;}
  .Labor_cost_statistics main{background: #fff;padding: 16px;}
  .Labor_cost_statistics main thead th:first-child{border-left:none;}
  </style>